import request from '@/utils/request'

// 查询商品-信息列表
export function listGoods(query) {
  return request({
    url: '/platform/goods/list',
    method: 'get',
    params: query
  })
}

// 查询商品-信息分页
export function pageGoods(query) {
  return request({
    url: '/platform/goods/page',
    method: 'get',
    params: query
  })
}

// 查询商品-信息详细
export function getGoods(data) {
  return request({
    url: '/platform/goods/detail',
    method: 'get',
    params: data
  })
}

// 新增商品-信息
export function addGoods(data) {
  return request({
    url: '/platform/goods/add',
    method: 'post',
    data: data
  })
}

// 修改商品-信息
export function updateGoods(data) {
  return request({
    url: '/platform/goods/edit',
    method: 'post',
    data: data
  })
}

// 删除商品-信息
export function delGoods(data) {
  return request({
    url: '/platform/goods/delete',
    method: 'post',
    data: data
  })
}
